// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"3ead1eba","89":"dbd9876a","430":"23ea1eb1","937":"895bc396"}[chunkId] + ".chunk.js";
};